import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faStore } from '@soundxyz/font-awesome/pro-solid-svg-icons/index.mjs';
import { DataTestId } from '@utils/test';

export function CollectOnSoundMarket() {
  return (
    <div
      data-testid={DataTestId.COLLECT_ON_SOUND_MARKET_BADGE}
      className="line flex h-6 flex-shrink-0 items-center rounded-sm bg-base900 px-2 font-base text-base-s font-semibold text-white"
    >
      <FontAwesomeIcon icon={faStore} />
    </div>
  );
}
